import {Component} from "@angular/core";
import {TabsPageContainer} from "../../uiComponents/tabsPageContainer";

@Component({
	selector: 'archive-configuration-tabs',
	templateUrl: './archive-configuration-tabs.component.html',
})
export class ArchiveConfigurationTabsComponent extends TabsPageContainer {
}
